import React from 'react';
import useCurrentUser from '../../../../hooks/useCurrentUser';
import { useNavigate } from 'react-router-dom';
import AvatarProfileIcon from '@/assets/icon/components/AvatarProfileIcon';
import styles from './userInfo.module.scss';
import { useAppSelector } from '@/store/reduxHooks';

export const UserInfo: React.FC = () => {
  const currentUser = useCurrentUser();
  const navigate = useNavigate();
  const { profile: accountData } = useAppSelector((state) => state.account);

  if (currentUser === null) {
    return (
      <span className="text-white user-info">Пользователь не определён</span>
    );
  }

  const hasSurname =
    typeof currentUser.surname === 'string' &&
    currentUser.surname.trim().length > 0;

  const handleClick = () => {
    navigate('/account');
  };

  const hasValidAvatar =
    accountData !== null &&
    accountData !== undefined &&
    accountData.avatar_image !== null &&
    accountData.avatar_image !== undefined &&
    accountData.avatar_image.link !== null &&
    accountData.avatar_image.link !== '' &&
    accountData.avatar_image.link.trim() !== '';

  return (
    <div className={styles.user_info} onClick={handleClick}>
      {hasValidAvatar ? (
        <div className={styles.user_info__avatar}>
          <img src={accountData?.avatar_image?.link} alt="Аватар" />
        </div>
      ) : (
        <div className={styles.user_info__placeholder}>
          <AvatarProfileIcon width={16} height={16} />
        </div>
      )}
      <span className={styles.user_info__name}>
        {currentUser.name}
        {hasSurname ? ` ${currentUser.surname}` : ''}
      </span>
    </div>
  );
};
